<!--

ViewData.vue
============

Used to create a panel with text, in the same way ViewEdit does
To use this add the viewEdit/ViewData.vue component and call it with:

<view-edit :data="data"
           :layout="layout" // the layout for the view and edit
           :inlineDisplay="true|false" // should the items be shown in line, or in a column

* data is the data to work with
* layout is how the data is to be presented. The object description is below

The layout object has the following format:
{
    id: [text], // id of component (Mandatory)
    editTitle: [text], // title to show on edit dialog (Mandatory)
    editSize: [class name], // dialog size class

    rows: [
        {
            columns: [
                {
                    width: <0-12>, // 0 = unset
                    title: <text>, // title of element (Mandatory)
                    subTitle: <text>, // sub title when two title are used (checkbox, for example)
                    editType: <type of edit box>, // the "type" in an html input * (Mandatory)
                    attributeName: <text>/<function>, // name of the attribute in the object (or function for button) (Mandatory)
                    dropDownItems: <id /name array>, // array of id/name pairs for a type of "dropdown",
                    falseTrueNames: <[<false name>,<true name>]>, array of names for the true and false case.
                    viewClass: <string>, class used when viewing.
                    outline: <string>, outline specification used for viewing
                    backgroundColor: <string>, background color used for both viewing and editing,
                    inlineDisplay: shows the items inline ([title]: [content], instead of as heading/body (default false)
                }, ...
            ]
        }, ...
    ]
}

* editType -
 edit type is the type for a simple input, or it can be
 - [input types] : any input type, like "text", "number", "date" or "checkbox"
 - "textarea" for a textarea edit control and multi-line view
 - "dropdown" for a select list. This requires "dropDownItems" to be populated. The view is the current value from the list
 - "resourceImage" for a resource image. This will come from the organisations "Images" resource
 - "mp4VideoLink" for a link to an mp4 video. In edit this is a simple text field, in view it is a player
 - "embeddedVideoLink" for a link to an embeddedvideo (probably YouTube). In edit this is a simple text field, in view it is a player
 - "vimeoLink" for a link to a Vimeo video. In edit this is a simple text field, in view it is a player
 - "richtext" for a rich text editor and viewer
 - "button" to show a button. Attribute name will now be a callback function name. className needs to have the icon class to use (e.g. "icon-pencil")

-->



<template>
    <!-- Always visible View section -->
    <div :style="dispStyle">
        <view-edit-view :data="preparedData"
                        :layout="layout" />
    </div>
</template>
<script setup>
    import { computed, defineProps, onMounted, defineAsyncComponent } from 'vue';
    import { Tooltip } from 'bootstrap';
    import { generateData } from '../../js/ViewEditUtilities.js';
    const ViewEditView = defineAsyncComponent(() => import('./impl/ViewEditView.vue'));


    const props = defineProps({
        data: {
            type: Object,
            default: null
        },
        layout: {
            type: Object,
            default: null
        },
    });

    onMounted(() => {
        new Tooltip(document.body, {
            selector: "[data-bs-toggle='tooltip']",
        });
    })

    const dialogId = computed(() => `editdialog-${props.layout.id}`);
    const preparedData = computed(() => generateData(props.data, props.layout));

</script>
